import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { createCustomToast } from 'services/toasts';
import Icon from 'components/Icon';
import { layout, effects } from 'styles';

interface Props {
    children: React.ReactNode;
    text: string;
    onSuccess?: () => void;
    className?: string;
    iconSize?: number;
}

const CopyButton: React.FC<Props> = ({ children, text, onSuccess, className, iconSize = 18 }) => {
    const { t } = useTranslation();

    const handleCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            if (onSuccess) {
                onSuccess();
            }

            createCustomToast('success', t('Common.Actions.CopiedToClipboard'));
        });
    };

    return (
        <div onClick={handleCopy} className={clsx(layout.flexRow, layout.gap1, effects.clickable, className)}>
            {children}
            <Icon name="copy" color="gray2" width={iconSize} />
        </div>
    );
};

export default React.memo(CopyButton);
